module.exports = __webpack_public_path__ + "static/media/concert4.cd3eda14.jpg";